<template>
  <v-container>
    <v-row><v-col><recent-films /></v-col></v-row>
    <v-row><v-col><watched-films /></v-col></v-row>
    <v-row><v-col><reviewed-films /></v-col></v-row>
    <v-row><v-col><recent-lists /></v-col></v-row>
  </v-container>
</template>

<script>
import RecentFilms from "@/components/films/RecentFilms"
import WatchedFilms from "@/components/films/WatchedFilms"
import ReviewedFilms from "@/components/films/ReviewedFilms"
import RecentLists from "@/components/lists/RecentLists"

export default {
  name: "Home",
  components: {
    RecentFilms,
    WatchedFilms,
    ReviewedFilms,
    RecentLists,
  },
}
</script>
